import { UserType } from 'api'

export namespace permissions {
  export const canCreateRecipient: UserType[] = [UserType.OWNER, UserType.ADMIN, UserType.NORMAL, UserType.DEBUG]
  export const canEditRecipient: UserType[] = [UserType.OWNER, UserType.ADMIN, UserType.NORMAL, UserType.DEBUG]
  export const canViewRecipient: UserType[] = [UserType.OWNER, UserType.ADMIN, UserType.NORMAL, UserType.DEBUG]
}

export default permissions
